require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-reasonable-vscode-starter.json") })
        }
      }, "path---package-unpublished-glennsl-reasonable-vscode-starter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-reasonable-vscode-starter!./.cache/json/package-unpublished-glennsl-reasonable-vscode-starter.json
// module id = 945
// module chunks = 231608221292675